import React, { useState } from 'react';
import {
    Button,
    Box
} from '@mui/material';
import { Add, Delete } from '@mui/icons-material';
import ImageCropper from './imageCropper';

interface ImageSelectorProps {
    onImageSelected: (file: File, imageUrl: string) => void;
    existingImageUrl: string | null | undefined;
    onDeleteImage: () => void;
    aspectRatio?: number; // 幅/高さの比率
    buttonLabel?: string;
}

const ImageSelector: React.FC<ImageSelectorProps> = ({
    onImageSelected,
    existingImageUrl,
    onDeleteImage,
    aspectRatio = 4 / 3, // デフォルトは4:3
    buttonLabel = '写真を選択'
}) => {
    const [openCropper, setOpenCropper] = useState(false);
    const [selectedFile, setSelectedFile] = useState<File | null>(null);

    const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files[0]) {
            setSelectedFile(event.target.files[0]);
            setOpenCropper(true);
        }
    };

    const handleCropComplete = (croppedImageUrl: string, croppedBlob: Blob) => {
        // 新しいFileオブジェクトを作成（元のファイル名を保持）
        const fileName = selectedFile?.name || 'cropped_image.jpg';
        const fileType = selectedFile?.type || 'image/jpeg';
        const croppedFile = new File([croppedBlob], fileName, { type: fileType });

        onImageSelected(croppedFile, croppedImageUrl);
    };

    return (
        <>
            <Box display="flex" gap={1}>
                <Button
                    variant="outlined"
                    component="label"
                    size="small"
                    startIcon={<Add />}
                >
                    {buttonLabel}
                    <input
                        type="file"
                        hidden
                        accept="image/*"
                        onChange={handleFileSelect}
                    />
                </Button>
                {existingImageUrl != null && (
                    <Button
                        variant="outlined"
                        color="error"
                        size="small"
                        onClick={onDeleteImage}
                    >
                        削除
                    </Button>
                )}
            </Box>

            {/* トリミングダイアログ */}
            <ImageCropper
                open={openCropper}
                onClose={() => setOpenCropper(false)}
                onCropComplete={handleCropComplete}
                aspectRatio={aspectRatio}
                imageFile={selectedFile}
            />
        </>
    );
};

export default ImageSelector;